import { Components, Theme } from '@mui/material/styles'

export const typographyTheme: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    color: 'textPrimary',
  },
}
